<template>
  <div id="settleAffirm">
    <table-title>了结确认信息</table-title>
    <Form ref="formValidates" :model="formValidate" :label-width="120" inline :rules="ruleValidate">
      <Divider orientation="left">物流详情(只读)</Divider>
      <FormItem label="物流任务ID">
        <Input v-model="disableVal.logisticTaskId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="物流子任务ID">
        <Input v-model="formValidate.logiSubTaskId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="收货省市区">
        <Input v-model="disableVal.toAreaId" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="收货仓库">
        <Input v-model="disableVal.toWarehouseId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="发货仓库">
        <Input v-model="disableVal.fromWarehouseId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="关联运单号">
        <Input v-model="disableVal.waybillId" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="标的物小类">
        <Input v-model="disableVal.targetSubClassCode" disabled style="width:180px" />
      </FormItem>
      <FormItem label="标的物编码">
        <Input v-model="disableVal.targetCode" disabled style="width:180px" />
      </FormItem>
      <FormItem label="计划数量">
        <Input v-model="disableVal.planQty" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="出库数量">
        <Input v-model="disableVal.shippingQty" disabled style="width:180px" />
      </FormItem>
      <!-- <FormItem label="出库时间">
        <Input v-model="disableVal.shippingDate" disabled style="width:180px" />
      </FormItem> -->
      <FormItem label="接收数量">
        <Input v-model="disableVal.receiveQty" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="接收时间">
        <Input v-model="disableVal.receiveDate" disabled style="width:180px" />
      </FormItem>
      <Divider orientation="left">了结确认</Divider>
      <!-- <FormItem label="交接单" >
                <Input v-model="formValidate.receiveNoteId" style="width:180px" />
            </FormItem>-->
      <FormItem label="签收数量" prop="receiveQty">
        <InputNumber :min="0" v-model="formValidate.receiveQty" placeholder="请输入签收数量" style="width: 180px" />
      </FormItem>
      <FormItem label="签收时间" prop="receiveTime">
        <DatePicker type="date" placeholder="请选择签收时间" :editable="false" @on-change="onReceiveTime" v-model="formValidate.receiveTime" style="width:180px"></DatePicker>
      </FormItem>
      <br />
      <FormItem label="退回数量" prop="returnQty">
        <InputNumber :min="0" v-model="formValidate.returnQty" :disabled="disableVal.targetSubClassCode?false:true" placeholder="请输入出库数量" style="width: 180px" />
      </FormItem>
      <FormItem label="交接单有效性" prop="receiveNoteValidity">
        <Select v-model="formValidate.receiveNoteValidity" style="width:180px">
          <Option v-for="item in shippingNoteVal" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <br />
      <FormItem label="退回仓库">
        <dict-select namespace="bizObjects" id="ValidWarehouse" :width="180" :exclusion="[]" v-model="formValidate.returnWarehouseId" />
      </FormItem>
      <FormItem label="退回时间">
        <DatePicker type="date" placeholder="请选择退回时间" :editable="false" @on-change="onreturnTime" v-model="formValidate.returnTime" style="width:180px"></DatePicker>
      </FormItem><br>
      <FormItem label="退回运费" prop="returnFee">
        <InputNumber :min="0" v-model="formValidate.returnFee" placeholder="请输入" style="width: 180px" />
      </FormItem>
      <FormItem label="品种确认" v-if="showVarietyStatus" prop="varietyStatus">
        <dict-select namespace="ENUM_MID-OPERATE-LOGISTICS" id="logisticSubTaskService.VarietyStatusEnum" :width="180" v-model="formValidate.varietyStatus" />
      </FormItem>
      <br />
      <FormItem label="备注">
        <Input type="textarea" :rows="2" v-model="formValidate.subTaskStopComment" style="width: 490px" />
      </FormItem>
      <br />
      <FormItem label="上传交接单">
        <upload v-if="isRequireDeliveryNotes" ref="upFiles" :height="70" :width="489" title="上传交接单" @success="uploadSuccess" @delete="onDelete" />
        <viewer v-else>
          <img class="img" v-for="file in formValidate.receiveNoteIdList" :key="file" :src="localUtil.downloadUrl() + file" :onerror="errorImg" style="width: 100px; height: 100px; margin-right: 20px">
        </viewer>
      </FormItem>

      <!-- <div v-if="data.souceBizCode=='WH_ADJUST'&&!data.targetCode">
        <Divider orientation="left">分拣入库</Divider>
        <Button type="success" size="small" @click="addLine" style="margin:10px">添加</Button>
        <Table :data="sortList" :columns="columns" border style="width: 1300px;">
          <template slot-scope="{ row, index }" slot="targetCode">
            <bizSelect :value="row.targetCode" @onChange="(val)=>sortList[index].targetCode = val" url="http://CORE-TARGET/messageService/baseInfoService/queryTargetsByType" :params="{targetType:data.targetSubClassCode}" codeField="code" style="width:200px" />
          </template>
          <template slot-scope="{ row, index }" slot="quality">
            <dict-select :value="row.quality" @on-change="(val)=>sortList[index].quality = val" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" :exclusion="['UNKNOWN']" />
          </template>
          <template slot-scope="{ row, index }" slot="num">
            <InputNumber :value="row.num" @on-change="(val)=>sortList[index].num = val" style="width: 150px;" />
          </template>
          <template slot-scope="{ row, index }" slot="destroyResponsibleMember">
            <dict-select :value="row.destroyResponsibleMemberId" @on-change="(val)=>sortList[index].destroyResponsibleMemberId = val" namespace="bizObjects" id="member" :includes="[data.fromMemberId]" placeholder="非必填,需明确损坏责任时选择" style="width:350px" />
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <Button type="error" size="small" @click="removeLine(index)">删除</Button>
          </template>
        </Table>
      </div> -->
    </Form>
    <div style="margin: 30px 200px">
      <Button @click="reset" style="width: 120px">重置</Button>
      <Button type="primary" style="margin-left:20px; width: 120px" @click="submint">提交</Button>
      <Button type="warning" style="margin-left:20px; width: 120px" @click="goBack">返回</Button>
    </div>
  </div>
</template>

<script>
import tableTitle from "@/components/tableTitle/tableTitle.vue";
import dictSelect from "@/components/select/dict-select.vue";
import upload from "@/components/upload/upload";
import bizSelect from "@/components/select/biz-select.vue";

export default {
  components: {
    tableTitle,
    dictSelect,
    upload,
    bizSelect,
  },
  props: ["data"],
  data() {
    return {
      disableVal: {},
      formValidate: {
        logiSubTaskId: "",
        receiveQty: null,
        receiveTime: "",
        receiveNoteId: "", //交接单
        receiveNoteValidity: "Y", //交接有效性
        subTaskStopComment: "",
        returnQty: 0,
        returnTime: "", //退回时间
        returnWarehouseId: "", //退回仓库
        receiveNoteIdList: [], //上传附件
        returnFee: 0,
        varietyStatus: "", // 品种确认
      },
      showVarietyStatus: false, // 是否展示品种确认下拉框
      ruleValidate: {
        receiveQty: [{ required: true, message: "输入签收数量" }],
        receiveTime: [{ required: true, message: "请选择签收时间" }],
        receiveNoteId: [{ required: true, message: "请输入交接单" }],
        returnQty: [{ required: true, message: "输入退回数量" }],
        receiveNoteValidity: [{ required: true, message: "请选择交接单有效性", trigger: "change" }],
        returnFee: [{ required: true, message: "请输入退回运费" }],
        varietyStatus: [{ required: true, message: "请选择" }],
      },
      shippingNoteVal: [
        { value: "Y", label: "有效" },
        { value: "N", label: "无效" },
      ],
      sortList: [],
      columns: [
        { title: "标的物", slot: "targetCode" },
        { title: "品质类型", slot: "quality" },
        { title: "数量", slot: "num" },
        { title: "损坏责任人", slot: "destroyResponsibleMember", width: 400 },
        { title: "操作", slot: "action" },
      ],
      isRequireDeliveryNotes: true,
    };
  },
  // watch: {
  //   $route(to, from) {
  //     this.createdFunC();
  //   },
  // },
  activated() {
    this.createdFunC();
  },
  methods: {
    async createdFunC() {
      this.getRouteParameterIfPossible();
      this.formValidate.receiveQty = null;
      this.formValidate.receiveTime = null;

      this.formValidate.logiSubTaskId = this.data.logisticSubTaskId;

      this.disableVal.logisticTaskId = this.data.logisticTaskId;
      this.disableVal.toAreaId = this.data.toAreaId ? this.$options.filters["queryDict"]("region", "fullArea", this.data.toAreaId) : "";
      this.disableVal.toWarehouseId = this.data.toWarehouseId ? this.$options.filters["queryDict"]("bizObjects", "warehouse", this.data.toWarehouseId) : "";
      this.disableVal.waybillId = this.data.waybillId;
      this.disableVal.targetSubClassCode = this.data.targetSubClassCode ? this.$options.filters["queryDict"]("target", "type", this.data.targetSubClassCode) : "";
      this.disableVal.fromWarehouseId = this.data.fromWarehouseId ? this.$options.filters["queryDict"]("bizObjects", "warehouse", this.data.fromWarehouseId) : "";

      this.disableVal.targetCode = this.data.targetCode ? this.$options.filters["queryDict"]("target", "targetCodeUnion", this.data.targetCode) : "";
      this.disableVal.planQty = this.data.planQty;
      this.disableVal.shippingQty = this.data.shippingQty;
      this.disableVal.receiveQty = this.data.receiveQty;
      this.disableVal.returnQty = this.data.returnQty;
      this.disableVal.shippingDate = this.data.shippingDate ? new Date(this.data.shippingDate).Format("yyyy-MM-dd") : "";
      this.disableVal.receiveDate = this.data.receiveDate ? new Date(this.data.receiveDate).Format("yyyy-MM-dd") : "";
      this.disableVal.returnDate = this.data.returnDate ? new Date(this.data.returnDate).Format("yyyy-MM-dd") : "";
      await this.checkOpenRecycleSort();
    },
    // 判断是否需要展示了解确认下拉框
    async checkOpenRecycleSort() {
      let url = "http://MID-OPERATE-LOGISTICS/messageService/logisticSubTaskService/checkOpenRecycleSort";
      this.showVarietyStatus = await this.invoke(url, { logiSubTaskId: this.formValidate.logiSubTaskId });
    },
    getRouteParameterIfPossible() {
      let { task, fileIds, fileDocId } = this.$route.query;

      if (task) this.data = JSON.parse(task);
      console.log(this.data, "this.data");
      // 表示进入这个页面的时候, 路由参数中包含签收单, 这里不再需要上传
      if (fileIds) {
        this.formValidate.receiveNoteIdList = JSON.parse(fileIds);
        this.formValidate.receiveNoteId = fileDocId;
        this.isRequireDeliveryNotes = false;
      }
    },
    onReceiveTime(val) {
      this.formValidate.receiveTime = val;
    },
    // 退回时间
    onreturnTime(val) {
      this.formValidate.returnTime = val;
    },
    // 上传附件回调
    uploadSuccess(params) {
      this.formValidate.receiveNoteIdList.push(params.body);
    },
    // 上传附件删除回调
    onDelete({ id }) {
      this.formValidate.receiveNoteIdList = this.formValidate.receiveNoteIdList.filter((item) => item != id);
    },
    reset() {
      this.$refs["formValidates"].resetFields();
      this.$refs?.upFiles?.$refs?.uploadFile?.clearFiles();
      this.formValidate.receiveNoteIdList = [];
      this.formValidate.receiveNoteId = "";
      this.formValidate.subTaskStopComment = "";
      this.isRequireDeliveryNotes = true;
      this.formValidate.returnTime = "";
      this.formValidate.returnWarehouseId = "";
      this.sortList = [];
    },
    addLine() {
      this.sortList.push({ targetCode: "", quality: "", num: "" });
    },
    removeLine(index) {
      this.sortList.splice(index, 1);
    },
    async submint() {
      //如果有分拣列表则进行进行数量校验
      if (this.sortList.length > 0) {
        let total = 0;
        this.sortList.forEach((item) => (total += item.num));
        if (total != this.formValidate.receiveQty) {
          this.$Message.error("分拣数量与总数不符!");
          return;
        }
      }
      this.formValidate.sortList = this.sortList;
      let valid = await this.$refs["formValidates"].validate();
      if (!valid) return;
      let url = "MID-OPERATE-LOGISTICS/messageService/logisticSubTaskService/logiSubTaskReceive";

      if (this.formValidate.receiveQty + this.formValidate.returnQty < this.disableVal.shippingQty) {
        const h = this.$createElement;
        this.$msgbox({
          title: "提示",
          message: h("p", null, [h("span", { style: "color: red" }, "出库数量>签收数量+退回数量，有货品丢失确定提交吗")]),
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              this.invoke(url, this.formValidate).then((res) => {
                this.reset();
                this.goBack();
                this.$Message.success("操作成功!");
                done();
              });
            } else {
              done();
            }
          },
        });
      } else {
        this.cfmInvoke(url, this.formValidate).then((res) => {
          this.reset();
          this.goBack();
        });
      }
    },
    goBack() {
      this.reset();
      this.$router.push("/user-center/storage/putInStorage");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>